const isEmpty = obj =>
  [Object, Array].includes((obj || {}).constructor) &&
  !Object.entries(obj || {}).length

const hasDOM = typeof window !== 'undefined'

const get_valid_access_key = (access_keys = []) => {
  const access_key = access_keys.find(key => key?.valid)

  return access_key ? access_key.SK.replace('ACCESS_KEY#', '') : ''
}

export { isEmpty, hasDOM, get_valid_access_key }
